/**
 * PartialIndexNotice: the site index is still being populated, so missing sites are expected.
 */
import { Link } from 'react-router-dom';

interface PartialIndexNoticeProps {
  readonly searchString: string;
}

export function PartialIndexNotice({ searchString }: PartialIndexNoticeProps): JSX.Element {
  return (
    <aside className="site-map-notice" aria-label="About this map">
      <p>
        Sites appear on the map once their location has been published, so not every site is
        shown yet.
      </p>
      <p>
        You can still open any site by its ID from the <Link to={`/site${searchString}`}>Sites page</Link>.
      </p>
    </aside>
  );
}
